<template>
<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div class="custom_card table_card chart_card">
    <div class="chart_component" :class="{ diff: show }">
      <span v-if="!withoutIcon" :style="{ color: color }" class="icon"
        ><i :class="[icon]"></i
      ></span>
      <span class="title">{{ title }}</span>
      
      <h3
        class="number"
        v-if="link == null && routeLink == null && number != null && arr == null"
      >
        <span class="num-val">{{ number }}</span>
        <div class="split" v-if="withoutIcon && completedAmount != null">
          <div class="split-item done">
            <span class="split-label"><i class="fal fa-check-circle"></i> مكتمل</span>
            <span class="split-val">{{ Number(completedAmount).toLocaleString() }}</span>
          </div>
          <div class="split-item wait" :class="{ active: pendingAmount > 0 }">
            <span class="split-label"><i class="fal fa-hourglass-half"></i> قيد الانتظار</span>
            <span class="split-val">{{ Number(pendingAmount).toLocaleString() }}</span>
          </div>
        </div>
        <div class="detailed" v-if="withoutIcon">
          <span class="completed">مكتمل ( {{ completed }} )</span>
          <span :class="{'pending': pending == 0, 'pending_red': pending > 0 }">قيد الانتظار ( {{ pending }} )</span>
          <span v-if="total != null" class="saved-info">محدد ({{ saved }}) من ({{ total }})</span>
        </div>
      </h3>
      <h3 class="number" v-if="number == null">لا يوجد</h3>
      <h3 class="number" v-if="arr && number != null" v-for="i in number" :key="i.id">
        {{ i.name_ar }}
      </h3>
      <a :href="link" class="number" v-if="link != null" target="_blank">{{
        link
      }}</a>
      <router-link
        v-if="routeLink != null"
        class="number"
        :to="'/enterpriceOwners/show/' + routeLink"
      >
        {{ number }}
      </router-link>
      <slot> </slot>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: [
    "icon",
    "number",
    "title",
    "bgColor",
    "color",
    "show",
    "link",
    "routeLink",
    "arr",
    "withoutIcon",
    "completed",
    "pending",
    "saved",
    "total",
    "completedAmount",
    "pendingAmount"
  ],

  components: {
    VueApexCharts,
  },
};
</script>

<style lang="scss" scoped>
.custom_card {
  margin: 0 !important;
  padding: 15px;

  .chart_component {
    position: relative;
    width: 100%;

    .number {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      gap: 6px 12px;
      white-space: normal !important;
      overflow: visible !important;
      height: auto !important;
      flex-direction: column;
      margin-top: 8px;

      .num-val {
        font-size: 28px;
        font-weight: bold;
        white-space: nowrap;
        line-height: 1.2;
      }

      .split {
        display: flex;
        gap: 8px;
        width: 100%;
        font-weight: normal;

        .split-item {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 2px;
          padding: 6px 10px;
          border-radius: 10px;
          border-inline-start: 3px solid;

          .split-label {
            font-size: 11px;
            line-height: 1.3;
            white-space: nowrap;

            i {
              margin-inline-end: 3px;
            }
          }

          .split-val {
            font-size: 15px;
            font-weight: 700;
            line-height: 1.3;
            white-space: nowrap;
          }
        }

        .done {
          background: linear-gradient(135deg, #e8f7ec, #f4fbf6);
          border-color: #080;
          color: #080;
        }

        .wait {
          background: linear-gradient(135deg, #f1f3f6, #f9fafb);
          border-color: #8a94a3;
          color: #525e6e;

          &.active {
            background: linear-gradient(135deg, #fff0f0, #fff8f8);
            border-color: #f00;
            color: #d00;
          }
        }
      }

      .detailed {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 8px;
        font-weight: normal;

        span {
          font-size: 13px;
          line-height: 1.3;
          white-space: nowrap;
          display: inline-block;
        }

        .completed {
          color: #080;
          font-weight: 600;
        }

        .pending {
          color: #525e6e;
        }

        .pending_red {
          color: #f00;
          font-weight: 600;
        }

        .saved-info {
          color: #1976d2;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
